import { IViewHistoryChange, IViewHistoryItemsGroupedReqParams, ViewHistoryItemSource } from "@gtmhub/view-history";
import { INavItem } from "@webapp/navigation/models/nav-items-list.models";
import { ICollection } from "@gtmhub/models";
import { UXCustomizationType } from "@gtmhub/uxcustomization/models";
import { RequestPaging } from "@webapp/core/abstracts/models/request.paging";

export class ViewHistoryFactory {
  public buildNavigationViewHistoryQueryParams(types: UXCustomizationType[]): RequestPaging {
    const requestPaging: RequestPaging = {
      ...new RequestPaging(),
      filter: {
        $and: [
          {
            type: {
              $in: types,
            },
          },
          {
            source: {
              $in: ["navigation"],
            },
          },
        ],
      },
    };
    return requestPaging;
  }

  public buildNavigationViewHistoryRequestParams(types: UXCustomizationType[]): IViewHistoryItemsGroupedReqParams {
    return {
      filter: {
        $and: [
          {
            type: {
              $in: types,
            },
          },
          {
            source: {
              $in: ["navigation"],
            },
          },
        ],
      },
    };
  }

  public buildRecentChangeHandler(
    types: UXCustomizationType[],
    source: ViewHistoryItemSource
  ): (changeEvent: IViewHistoryChange, recent: ICollection<INavItem>) => ICollection<INavItem> {
    return (changeEvent: IViewHistoryChange, recent: ICollection<INavItem>) => {
      if (types.indexOf(changeEvent.type) !== -1 && changeEvent.source === source) {
        if (recent.items.find((item) => item.id === changeEvent.item.id)) {
          recent.items = recent.items.filter((item) => item.id !== changeEvent.item.id);
        } else {
          recent.totalCount++;
          recent.count++;
        }
        recent.items = [changeEvent.item, ...recent.items];
      }
      return recent;
    };
  }

  public buildRecentPatchHandler(
    types: UXCustomizationType[],
    source: ViewHistoryItemSource
  ): (changeEvent: IViewHistoryChange, recent: ICollection<INavItem>) => ICollection<INavItem> {
    return (changeEvent: IViewHistoryChange, recent: ICollection<INavItem>) => {
      if (types.indexOf(changeEvent.type) !== -1 && changeEvent.source === source && recent.items.find((item) => item.id === changeEvent.item.id)) {
        recent.items = recent.items.map((item) => {
          if (item.id === changeEvent.item.id) {
            return {
              ...item,
              title: changeEvent.item.title || item.title,
              color: changeEvent.item.color || item.color,
            };
          } else {
            return item;
          }
        });
      }
      return recent;
    };
  }
}
